import iosLogo from "../images/iosLogo.png"
import androidLogo from "../images/androidLogo.png"


const AppDownloadLinks = () => {
    const isMobileOrTablet = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

    if (!isMobileOrTablet) {
        return null
    }

    return (
        <div className="app-links-container">
            <a
                href="https://apps.apple.com/qa/app/sigurica-ai/id6748994181?platform=iphone"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={iosLogo} alt="Download on iOS" className="app-download-logo" />
            </a>

            <a
                href="https://play.google.com/store/apps/details?id=app.bendingbytes.brainbet&pli=1"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={androidLogo} alt="Download on Android" className="app-download-logo" />
            </a>
        </div>
    );
};

export default AppDownloadLinks;
